import { FieldContainer } from '../functional'

interface HiddenFieldProps {
   name: string
}

const HiddenField: React.FC<HiddenFieldProps> = ({ name }) => {
   return (
      <FieldContainer name={name}>
         {(fieldProps) => <input {...fieldProps} hidden key={name} />}
      </FieldContainer>
   )
}

export default HiddenField
